<template>
  <div class="lh-container-custom-gutters">
    <div
      :class="[
        'padding-top-m padding-bottom-l medium-padding-right-s medium-padding-left-s',
        'small-padding-left-s small-padding-right-s loyalty-header-border margin-bottom-m',
      ]"
    >
      <!-- loyalty-logo -->
      <div>
        <img
          :src="isBcom ? loyallistAssociationLogo : starRewardsLogo"
          alt="loyallistlogo"
        />
      </div>
      <!-- loyalty-description -->
      <div class="small-margin-top-s medium-margin-top-m margin-top-l">
        <div :class="filteredLoyaltyInfo.emailLookupMembershipExists ? 'margin-bottom-xs' : 'margin-bottom-xxs'">
          <h3
            v-if="filteredLoyaltyInfo.emailLookupMembershipExists"
            class="link-for-benifits"
          >
            {{ ASSOCIATION_PAGE_HEADER.LINK_FOR_MORE_BENEFITS }}
          </h3>
          <h2 v-else>
            {{ ASSOCIATION_PAGE_HEADER.YOU_SHOP_REWARD }}
          </h2>
        </div>
        <div>
          <p
            v-if="filteredLoyaltyInfo.emailLookupMembershipExists"
            class="body large small-margin-bottom-s medium-margin-bottom-s margin-bottom-s"
          >
            <span class="exsisting-loyalist"
              >{{ ASSOCIATION_PAGE_HEADER.EMAIL_ASSOCIATED }}
              <button
                v-tooltip.bottom="{ value: tooltipValue, escape: false }"
                class="tooltip-small tooltip-position"
              ></button>
            </span>
          </p>
          <h4
            v-else
            class="small-margin-bottom-s medium-margin-bottom-m margin-bottom-l"
          >
            {{ ASSOCIATION_PAGE_HEADER.INVITED_TO_SPEND_MORE }}
          </h4>
        </div>
      </div>
      <!-- join-loyalty-program -->
      <div
        v-if="filteredLoyaltyInfo.emailLookupMembershipExists"
        class="link-your-account"
      >
        <div>
          <button
            class="primary button button-small device-button-width"
            @click.stop="triggerSlideout('manage-membership-slideout', MANAGE_MEMBERSHIP, 'manageMembership')"
          >
            {{ ASSOCIATION_PAGE_HEADER.LINK_YOUR_ACCOUNT }}
          </button>
        </div>
      </div>
      <div
        v-else
        class="grid-x"
      >
        <div class="cell small-12 medium-6 large-6">
          <div :class="isBcom ? 'margin-bottom-s' : 'small-margin-bottom-xxs medium-margin-bottom-xs'">
            <p :class="ASSOCIATION_PAGE_HEADER.CLASS_SIGNUP_MEMBERSHIP">
              {{ ASSOCIATION_PAGE_HEADER.SIGN_UP_FOR_FREE }}
            </p>
          </div>
          <div
            v-if="ASSOCIATION_PAGE_HEADER.JOIN_NOW_CONTENT"
            :class="[
              'small-margin-bottom-s medium-margin-bottom-xl large-margin-bottom-xl',
              'mlarge-margin-bottom-s xlarge-margin-bottom-s large-padding-right-s',
            ]"
          >
            <p class="body large medium-padding-bottom-xxs mlarge-padding-bottom-z">
              {{ ASSOCIATION_PAGE_HEADER.JOIN_NOW_CONTENT }}
            </p>
          </div>
          <div>
            <button
              class="secondary button button-small device-button-width join-now-button"
              @click.stop="triggerSlideout('association-join-now-slideout', JOIN_LOYALLIST, 'associationJoinNow')"
            >
              {{ ASSOCIATION_PAGE_HEADER.SIGN_UP_JOIN_NOW }}
            </button>
          </div>
        </div>
        <div class="cell small-12 medium-6 large-6 signup-loyalty-cell-divider">
          <div :class="isBcom ? 'margin-bottom-s' : 'small-margin-bottom-xxs medium-margin-bottom-xs'">
            <p :class="ASSOCIATION_PAGE_HEADER.CLASS_SIGNUP_MEMBERSHIP">
              {{ ASSOCIATION_PAGE_HEADER.ALREADY_LOYALIST }}
            </p>
          </div>
          <div
            v-if="ASSOCIATION_PAGE_HEADER.ALREADY_MEMBER_CONTENT"
            class="margin-bottom-s"
          >
            <p class="body large">
              {{ ASSOCIATION_PAGE_HEADER.ALREADY_MEMBER_CONTENT }}
            </p>
          </div>
          <div>
            <button
              class="primary button button-small device-button-width"
              @click.stop="triggerSlideout('manage-membership-slideout', MANAGE_MEMBERSHIP, 'manageMembership')"
            >
              {{ ASSOCIATION_PAGE_HEADER.MANAGE_MY_MEMBERSHIP }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted } from 'vue';
import vTooltip from '@nuxt-common/atomic-ui/app/components/tooltip/tooltip';
import { brand, ASSOCIATION_PAGE_HEADER, ASSOCIATION_PAGE } from '../../config';
import loyallistAssociationLogo from '../../assets/images/loyallist-logo-association.svg';
import starRewardsLogo from '../../assets/images/star-rewards-logo-association.svg';
import { useLoyaltyHubStore } from '../../stores/useLoyaltyHubStore.js';
import { useSlideoutStore } from '../../stores/useSlideoutStore';
import { loadOverlayComponent } from '../../utils/loadOverlayComponent';

const { MANAGE_MEMBERSHIP, JOIN_LOYALLIST } = ASSOCIATION_PAGE;
const store = useLoyaltyHubStore();
const slideout = useSlideoutStore();
const unifiedLoyaltySummary = computed(() => store.unifiedLoyalty);
const filteredLoyaltyInfo = computed(() => unifiedLoyaltySummary.value?.points?.loyaltyPointsResponse.loyaltyInfo || {});
const tooltipValue = `<div class="small" style='color: white; width:252px;'>${ASSOCIATION_PAGE_HEADER.LINK_ACCOUNT_INFO}</div>`;
const isBcom = brand === 'bcom';

const triggerSlideout = async (id, title, component) => {
  slideout.setSlideout({
    id,
    title,
    component: await loadOverlayComponent(component),
  });
  await nextTick();
  slideout.open(id);
};

onMounted(async () => {
  // Updating star rewards/Loyalty enrollment to initial state
  store.starRewardsWithoutCC = null;
  store.loyallistEnrolled = null;
  store.accountAssociationResponse = null;
  store.otpVerification = null;
  store.loyallistWithCcOrLidOrPhone = null;
});
</script>







<style src="@csgIcons/_tooltip-small.scss" lang="scss"></style>
<style lang="scss" scoped>
.lh-container-custom-gutters:deep() {
  margin-right: rem-calc(20);
  margin-left: rem-calc(20);
  @include breakpoint(small down) {
    margin-right: rem-calc(0);
    margin-left: rem-calc(0);
  }
}
.tooltip-position {
  position: absolute;
  bottom: 0;
}
.exsisting-loyalist {
  position: relative;
}
@include breakpoint(medium up) {
  .signup-loyalty-cell-divider {
    border-left: $gray-3-border;
    padding-left: rem-calc(32);
  }
}
@include breakpoint(large up) {
  .link-for-benifits {
    width: 78%;
  }
}
@include breakpoint(small down) {
  .signup-loyalty-cell-divider {
    border-top: $gray-3-border;
    margin-top: rem-calc(32);
    padding-top: rem-calc(32);
  }
  .device-button-width {
    width: 100%;
  }
}


.loyalty-header-border {
  background: $background-color;
  border-top: rem-calc(10) solid $loyalty-1-color;
}
.join-now-button {
  width: rem-calc(190);
  @include breakpoint(small down) {
    width: 100%;
  }
}
</style>